module.exports = fox._r("images/easter18/gift-68.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/easter18/gift-68.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/easter18/gift-68.png
// module id = 269
// module chunks = 4